module.exports = __webpack_public_path__ + "img/comm_16.60d7fe8f.jpg";